import { IconPlus, IconReload } from '~/components/Icons'
import RedIcon from '~/components/RedIcon'
import CompanyLogo from '~/images/logos/companies/company-logo'
import type { ICostSummary } from '~/models/report.v2.server'

interface ItineraryCostSummaryProps {
  summary: ICostSummary
}

export function CostSummary({ summary }: ItineraryCostSummaryProps) {
  return (
    <div className="bg-neutral-100 rounded-xl p-2 px-4 items-start">
      <p className="text-xs font-semibold mt-0">Your points</p>

      {summary.conversions && summary.conversions?.length > 0 && (
        <div>
          <div className="-mx-2 flex flex-wrap">
            {summary.conversions?.map((conversion) => (
              <div
                key={conversion.icon}
                className="flex gap-3 items-center flex-row px-2 md:w-1/3 my-2"
              >
                <CompanyLogo company={conversion.icon} iconSize={16} />
                <div className="flex flex-col items-start">
                  <p className="md:text-p text-xs font-semibold m-0 text-left">
                    <span className="num-of-points">
                      {Intl.NumberFormat('default').format(conversion.points)}
                    </span>{' '}
                    {conversion.unit}
                  </p>
                  <p className="md:text-p text-xs m-0 text-left">
                    {conversion.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-3">
            {summary.conversionComments.length > 0
              ? summary.conversionComments.map((c, i) => (
                  <p className="text-neutral-600 text-xs" key={i}>
                    {c}
                  </p>
                ))
              : null}
          </div>
          <div className="flex items-center justify-center mx-auto my-4">
            <div className="border-t-2 border-neutral-300 flex-grow" />
            <div className="mx-4">
              <IconReload />
            </div>
            <div className="border-t-2 border-neutral-300 flex-grow" />
          </div>
        </div>
      )}

      <div className="-mx-2 flex flex-wrap">
        {summary.balances.map((balance) => (
          <div
            key={balance.icon}
            className="flex gap-3 items-center md:flex-row flex-col px-2 md:w-1/3 w-1/2 my-2"
          >
            <CompanyLogo company={balance.icon} iconSize={16} />
            <div className="flex flex-col md:items-start items-center">
              <p className="md:text-p text-xs font-semibold m-0 md:text-left text-center">
                <span className="num-of-points">
                  {Intl.NumberFormat('default').format(balance.points)}
                </span>{' '}
                {balance.unit}
              </p>
              <p className="md:text-p text-xs m-0 md:text-left text-center">
                {balance.name}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-center mx-auto my-4">
        <div className="border-t-2 border-neutral-300 flex-grow" />
        <div className="mx-4">
          <IconPlus />
        </div>
        <div className="border-t-2 border-neutral-300 flex-grow" />
      </div>
      <div className="airlines-fees-and-taxes flex gap-2 items-center">
        <RedIcon iconsvg="coins" />
        <div className="flex flex-col items-start ml-1">

          <p className="md:text-p text-xs font-semibold m-0">
            {summary.feesAndTaxes.map((fee, index) => (
              <span key={fee.currency} className="num-of-points">
                {Intl.NumberFormat('default', {
                  style: 'currency',
                  currencyDisplay: 'code',
                  currency: fee.currency,
                  maximumFractionDigits: 0,
                }).format(fee.points)}
                {summary.feesAndTaxes &&
                  index < summary.feesAndTaxes.length - 1 && (
                    <span className="mx-2">+</span>
                  )}
              </span>
            ))}
          </p>
          <p className="md:text-p text-xs">Airline fees & taxes</p>
        </div>
      </div>
    </div>
  )
}
